function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewDwonarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 1.39961L8.69844 8.59961L1.49844 1.39961",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewDwonarrow);
export default __webpack_public_path__ + "static/media/overviewDwonarrow.60631041a1dfb4820ea0fa75ff375d85.svg";
export { ForwardRef as ReactComponent };